import { render } from "./OldCheckoutPage.vue?vue&type=template&id=047b693e&scoped=true"
import script from "./OldCheckoutPage.vue?vue&type=script&lang=js"
export * from "./OldCheckoutPage.vue?vue&type=script&lang=js"

import "./OldCheckoutPage.vue?vue&type=style&index=0&id=047b693e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047b693e"]])

export default __exports__